module.exports = __webpack_public_path__ + "media/img/pages/companies/rheinmetall-82222b4bf844d817b14100b1422edaa7.png";